import { Category, Campaign, Collection } from '../types';

export const sortCollectionsByCategory = (
  categories: Category[],
  campaigns: Campaign[],
): Collection[] => {
  if (!categories?.length) {
    return [];
  }
  categories.sort(
    (a, b) => parseInt(a.position, 10) - parseInt(b.position, 10),
  );
  return categories.map((category) => {
    const categoryCampaigns = campaigns.filter((campaign) =>
      campaign?.category_ids?.includes(category.category_id),
    );
    return {
      ...category,
      campaigns: categoryCampaigns,
    };
  });
};
